import { ENQUEUE_SNACKBAR, CLOSE_SNACKBAR, REMOVE_SNACKBAR } from './constants';

export const enqueueSnackbar = notification => {
    const key = notification.options && notification.options.key;

    return {
        type: ENQUEUE_SNACKBAR,
        payload: {
            notification: {
                ...notification,
                key: key || new Date().getTime() + Math.random()
            }
        }
    };
};

export const closeSnackbar = key => ({
    type: CLOSE_SNACKBAR,
    payload: {
        dismissAll: !key, // dismiss all if no key has been defined
        key
    }
});

export const removeSnackbar = key => ({
    type: REMOVE_SNACKBAR,
    payload: {
        key
    }
});
